import { Injectable } from "@angular/core";
interface ContentMap
{
  [placeholderId: string]: any;
}

@Injectable()
export class PlaceholderContentService
{
  private contentMapByPart: {[partId: string]: ContentMap} = {};

  public async savePlaceholderContent(placeholder: any): Promise<void>
  {
    const info = await placeholder.extractInformation();

    if (!info || info.id.startsWith('auto')) {
      return;
    }

    this.putContent(placeholder, info);
  }

  public async restorePlaceholderContent(placeholder: any): Promise<any>
  {
    const info = this.getContent(placeholder);

    if (!info) {
      return;
    }

    await placeholder.applyInformation(info);
    return info;
  }

  private getContentMap(placeholder: any): ContentMap
  {
    const partId = placeholder.getPartId();

    if (Object.keys(this.contentMapByPart).indexOf(partId) === -1) {
      this.contentMapByPart[partId] = {};
    }

    return this.contentMapByPart[partId];
  }

  private putContent(placeholder: any, content: any): void
  {
    this.getContentMap(placeholder)[placeholder.get('id')] = content;
  }

  private getContent(placeholder: any): any
  {
    return this.getContentMap(placeholder)[placeholder.get('id')];
  }
}
